import React, { useState, useEffect } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import { GradientText, Wrapper } from '../PasserCommande/PasserCommande.styles'
import { useHistory, useParams } from 'react-router'
import Container from '../../Components/LayoutClient/container.component'
import { useSelector } from 'react-redux'
import { getCommandeFacture } from '../../api/commande'
import { payTarif, payTarifWithSavedCard } from '../../api/tarif'
import toast from 'react-hot-toast'
import File from '../../assets/img/file@2x.png'
import { useAuthenticatedFetch } from '../../hooks'
import { useTranslation } from 'react-i18next'

// Configure PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
function PayCommande() {
	const { id } = useParams()
	const history = useHistory()
	const [commande, setCommande] = useState(null)
	const [loading, setLoading] = useState(false)
	const [chargementEnCours, setChargementEnCours] = useState(false)
	const [factureBlobUrl, setFactureBlobUrl] = useState(null)
	const user = useSelector((state) => state.auth.token)
	const token = useSelector((state) => state.auth.token)
	const {t} = useTranslation()
	const {
		fetchResource,
		error: fetchError,
		loading: fetchLoading,
	} = useAuthenticatedFetch()

	const onSubmit = async (event) => {
		setLoading(true)
		try {
			event.preventDefault()
			const response = await payTarifWithSavedCard(
				{ commandeId: id },
				token
			)
			if (response.url) {
				window.location.href = response.url
			}
		} catch (error) {
			toast.error(t("payment_error_try_again"), {
				style: {
					fontFamily: 'Montserrat',
				},
			})
		} finally {
			setLoading(false)
		}
	}

	const fetchCommande = async () => {
		setChargementEnCours(true)

		try {
			const res = await getCommandeFacture(id, token)
			setCommande(res)
			console.log(res, id)

			// If facture exists, use authenticated fetch to get the blob URL
			if (res?.facture?.length > 0) {
				const factureResult = await fetchResource(res.facture[0], token)
				if (factureResult) {
					setFactureBlobUrl(factureResult)
				}
				if (fetchError) {
					console.log(fetchError)
					toast.error(t("error_loading_invoice"), {
						style: {
							fontFamily: 'Montserrat',
						},
					})
				}
			}
		} catch (error) {
			toast.error(t("transfer_request_err"), {
				style: {
					fontFamily: 'Montserrat',
				},
			})
		} finally {
			setChargementEnCours(false)
		}
	}

	const [isMobile, setMobile] = useState(() => window.innerWidth < 768);
	
	
		useEffect(() => {
			const checkIfMobile = () => {
				setMobile(window.innerWidth < 768);
			};
			window.addEventListener('resize', checkIfMobile);
	
			return () => window.removeEventListener('resize', checkIfMobile);
		}, []);

	useEffect(() => {
		fetchCommande()
	}, [id])

	const styles = {
		fileContainer: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			background: '#fff',
			padding: '15px',
			borderRadius: '8px',
			marginBottom: '15px',
			boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
			transition: 'transform 0.2s',
		},
		fileDetails: {
			display: 'flex',
			alignItems: 'center',
			gap: '1rem',
		},
		pdfContainer: {
			display: 'flex',
			alignItems: 'center',
			gap: '0.5rem',
		},
		fileName: {
			fontSize: '1rem',
			fontWeight: '500',
			color: '#25A6E4',
			cursor: 'pointer',
		},
		pdfViewerContainer: {
			height: 'calc(100vh - 20rem)',
			width : isMobile? '22rem' : '',
			overflow: 'auto',
			border: '2px dashed #000',
			marginTop: '1rem',

		},
		buttonContainer: {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
		},
		submitButton: {
			padding: '1rem 5rem',
			marginTop: '1rem',
			borderRadius: 5,
			cursor: 'pointer',
			color: 'white',
			marginRight: '1rem',
			background: '#50F5A9',
			border: 'none',
			fontSize: 20,
			fontFamily: 'Montserrat',
		},
		cancelButton: {
			padding: '1rem 4rem',
			marginTop: '1rem',
			borderRadius: 5,
			cursor: 'pointer',
			color: 'white',
			marginRight: '1rem',
			background: 'red',
			border: 'none',
			fontSize: 20,
			fontFamily: 'Montserrat',
		},
		loader: {
			display: 'inline-block',
			width: '20px',
			height: '20px',
			border: '3px solid rgba(255, 255, 255, 0.3)',
			borderRadius: '50%',
			borderTopColor: 'white',
			animation: 'spin 1s ease-in-out infinite',
		},
	}
	
	return (
		<Container>
			<Wrapper>
				<GradientText style={{ fontSize : isMobile? '2rem' : '2.5rem'}}
				>{t("payment").toUpperCase()}</GradientText>
				{chargementEnCours ? (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							backgroundColor: 'white',
							marginTop: '4rem',
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
						}}
					>
						<div className='customLoader'></div>
					</div>
				) : (
					<div>
						<div style={styles.pdfViewerContainer}>
							{commande?.facture?.length > 0 ? (
								factureBlobUrl ? (
									<Document
										file={factureBlobUrl}
										loading={null}
									>
										<Page pageNumber={1} />
									</Document>
								) : (
									<div style={styles.fileDetails}>
										<div style={styles.pdfContainer}>
											<img
												src={File}
												alt='PDF'
												style={{
													width: '20px',
													height: '20px',
												}}
											/>
											<span
												style={styles.fileName}
												onClick={async () => {
													const result =
														await fetchResource(
															commande.facture[0],
															token
														)
													if (result) {
														window.open(
															result,
															'_blank'
														)
													}
													if (fetchError) {
														console.log(fetchError)
													}
												}}
											>
												{t("view_invoice")}
											</span>
										</div>
									</div>
								)
							) : (
								<div
									style={{
										padding: '1rem',
										textAlign: 'center',
									}}
								>
									<p>
										{t("invoice_not_available")}
									</p>
								</div>
							)}
						</div>
						<div style={styles.buttonContainer}>
							{user?.premium ||
							(!user?.premium && commande?.prix === 0) ? (
								<button
									onClick={() => {
										history.push(`/commandes/list`)
									}}
									style={styles.submitButton}
								>
									{t("validate")}
								</button>
							) : (
								<form onSubmit={onSubmit}>
									<input
										type='text'
										hidden={true}
										name='commandeId'
										value={id}
									/>
									<div
										style={{
											width: '100%',
											fontFamily: 'Montserrat',
											paddingLeft: '1rem',
											paddingRight: '1rem',
											marginBottom: '1rem',
											marginTop: '1rem',
											display: 'flex',
											flexDirection: isMobile? 'column' : 'row',
											justifyContent: isMobile? 'center' :'space-between',
											 
										}}
									>
										<button
											role='link'
											type='submit'
											disabled={loading}
											style={styles.submitButton}
										>
											{loading ? (
												<div className='loader'></div>
											) : (
												t("pay")
											)}
										</button>
										<button
											onClick={() => {
												history.push(`/commandes/list`)
											}}
											style={styles.cancelButton}
										>
											 {t("pay_later")}
										</button>
									</div>
								</form>
							)}
						</div>
					</div>
				)}
			</Wrapper>
		</Container>
	)
}

export default PayCommande
